/**
 * Created by aaikepae on 4/5/17.
 */
import React from "react";
import DOMPurify from "dompurify";
import {parseURL} from "Common/utility/link"

class SafeHtmlElement extends React.Component {
  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
  }

  componentDidMount() {
    if (this.elementRef.current) {
      this.elementRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.html !== this.props.html && this.elementRef.current) {
      this.elementRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
    }
  }

  render() {
    return React.createElement(this.props.tagName || 'div', {
      ...this.props.elementProps,
      ref: this.elementRef
    });
  }
}

export default class Link extends React.Component {
  render() {
    const {config, location} = this.props;
    if (!config) {
      return null
    }
    const url = parseURL(config.getAttribute("href"), location, location);
    config.setAttribute("href", url);

    if (config.tagName == "A") {
      const attributes = Array.from(config.attributes).reduce(function (acm, item) {
        if (item.name == "class") {
          acm["className"] = item.value;
        } else if (item.name !== 'style') {
          acm[item.name] = item.value;
        }

        return acm
      }, {});
      return <SafeHtmlElement tagName="a" elementProps={attributes} html={config.innerHTML}/>
    }


    return <div ref={(nodeElement) => {
      nodeElement.appendChild(config)
    }}/>
  }
}

